/* eslint-disable @typescript-eslint/no-explicit-any */
import { ItemWithLabel } from '@innovyze/stylovyze/lib/components/Items';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, } from '@mui/material';
import { FORM_MODES } from '@innovyze/stylovyze/lib/utils/constants';
import { Field, useField } from 'formik';
import React, { useMemo } from 'react';
import { useMode } from './contexts/StylovyzeFormContext';
import useGetCombinedAttributes from './hooks/useGetCombinedAttributes';
import useGetCombinedEvents from './hooks/useGetCombinedEvents';
export default function InputSelect(props) {
    const { fieldAttrs, selectProps, onChange, onDebounceChange, menuItems, dataCy, helperText, networkError, } = props;
    const mode = useMode();
    const [field, meta] = useField(fieldAttrs);
    const { value } = meta;
    const combinedEvents = useGetCombinedEvents({
        fieldAttrs,
        onChange,
        onDebounceChange,
        helperText,
        networkError,
        onBlur: field.onBlur,
    });
    const { error, helperText: combinedHelperText } = useGetCombinedAttributes({
        networkError,
        helperText,
    });
    const getViewValue = useMemo(() => {
        const result = menuItems.find(menuItem => menuItem.value === field.value);
        return result && result.label ? result?.label : field.value;
    }, [field]);
    return (React.createElement(FormControl, { variant: "outlined", margin: mode === FORM_MODES.VIEW ? 'none' : 'normal', fullWidth: true }, mode === FORM_MODES.VIEW ? (React.createElement(ItemWithLabel, { label: selectProps.label, value: getViewValue })) : (React.createElement(React.Fragment, null,
        React.createElement(InputLabel, { error: error }, selectProps.label),
        React.createElement(Field, { as: Select, error: error, "data-cy": dataCy, ...field, ...selectProps, ...combinedEvents }, menuItems.map(menuItem => (React.createElement(MenuItem, { key: menuItem.key, value: menuItem.value, selected: menuItem.value === value }, menuItem.label
            ? menuItem.label
            : menuItem.value)))),
        combinedHelperText && (React.createElement(FormHelperText, { error: error }, combinedHelperText))))));
}
